import { render } from "./RecentlyModifiedDevices.vue?vue&type=template&id=63122286"
import script from "./RecentlyModifiedDevices.vue?vue&type=script&lang=js"
export * from "./RecentlyModifiedDevices.vue?vue&type=script&lang=js"

import "./RecentlyModifiedDevices.vue?vue&type=style&index=0&id=63122286&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__